import { Link } from "react-router";
import styled from "styled-components";

export const List = styled.ul`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing(2)};
	padding: ${({ theme }) => theme.spacing(2)} 0;
`;

export const ListItem = styled.li`
	${({ theme }) => theme.dropdown.item};
	display: flex;
	padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(4)};
`;
export const ListItemLink = styled(Link)`
	flex: 1;
	color: inherit;
	display: flex;
	text-decoration: none;
`;
export const ListItemTrailing = styled.span`
	display: flex;
	align-items: center;
	justify-content: end;
`;

export const ListItemTitleWrapper = styled.span`
	flex: 1;
	display: flex;
	flex-direction: column;
`;

export const ListItemSubtitle = styled.span`
	font-size: ${({ theme }) => theme.fonts.sizes.small};
	color: ${({ theme }) => theme.colors.palette.grey[70]};
`;
